import { ReactNode } from 'react';
import { useTheme } from '@mui/material/styles';
import MuiModal from '@mui/material/Modal';
import { Box, Typography } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export interface ModalProps {
  title?: string;
  titleType?: 'h6' | 'h3' | 'body1';
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
  actions?: ReactNode;
  sx?: object;
  actionsSx?: object;
  description?: string;
  id?: string;
  contentSx?: object;
}

export function Modal({
  title,
  titleType = 'h6',
  open,
  onClose,
  children,
  actions,
  sx,
  contentSx,
  actionsSx,
  description,
  id,
}: ModalProps) {
  const theme = useTheme();

  const containerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: { xs: '90%', md: 700 },
    backgroundColor: 'white',
    borderRadius: `${theme?.shape?.borderRadius}px`,
    boxShadow: 24,
    maxHeight: '90vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    ...sx,
  };
  const contentStyle = {
    p: 4,
    ...contentSx,
  };

  const buttonSytle = {
    position: 'absolute',
    top: -1,
    right: -1,
  };

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      aria-labelledby={title}
      aria-describedby={description || title}
      data-testid={`modal-${id}`}
    >
      <Box sx={containerStyle} className="modalContent">
        <Box sx={{ ...contentStyle }}>
          <IconButton sx={{ ...buttonSytle }} aria-label="close" onClick={onClose}>
            <CloseRoundedIcon />
          </IconButton>
          {title && (
            <Typography variant={titleType} sx={{ pb: 2 }}>
              {title}
            </Typography>
          )}
          {children}
        </Box>
        {actions && <Box sx={actionsSx}>{actions}</Box>}
      </Box>
    </MuiModal>
  );
}

export default Modal;
